import React, { useEffect, useState, useContext, useRef } from 'react';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { LOGOUT } from 'ConstComponents';

import { MerchantActivation as MERCHANT_ACTIVATE } from 'Components/Api/EzyPayAEPSAPI';

import Box from '@material-ui/core/Box';

import {
    Container,
    Grid,
    Paper,
    TextField,
    Button,
    CircularProgress
} from '@material-ui/core';

import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';

import { PrimaryButton } from 'Components/Inputes/CustomButton';
import HOCLoader from 'Components/Loader/HOCLoader';
import { FailTransactionResponse } from 'Components/Alert/FailTransactionResponse';
const CustomContainer = HOCLoader(Container);

export const EZPayAEPSMerchantActivation = () => {
    const classes = commonStyle();
    const [loadingOpen, setLoadingOpen] = useState(false);
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [ImagePAN, setPANImage] = useState('');
    const [AadharImageFront, setAadharFrontImage] = useState('');
    const [AadharImageBack, setAadharBackImage] = useState('');
    const [isAlertErrorOpen, setIsAlertErrorOpen] = useState(false);
    const [Message, setMessage] = useState('');
    const [status, setStatus] = useState('PROCESS');
    const [PANImageDimension] = useState({
        width: 300,
        height: 300
    });
    const [AadharFrontImageDimension] = useState({
        width: 300,
        height: 300
    });

    const [AadharBackImageDimension] = useState({
        width: 300,
        height: 300
    });

    const [FormObj, setFormObj] = useState({
        PANImage: {
            Name: '',
            Size: '',
            Type: '',
            Data: ''
        },

        AadharFrontImage: {
            Name: '',
            Size: '',
            Type: '',
            Data: ''
        },

        AadharBackImage: {
            Name: '',
            Size: '',
            Type: '',
            Data: ''
        }
    });

    const FormValidationSchema = Yup.object({});

    const submithandle = async (values, { setSubmitting, resetForm }) => {
        var requestObj = JSON.stringify(values);

        const { isAuthorized, status, data } = await MERCHANT_ACTIVATE(
            requestObj
        );

        if (!isAuthorized) LOGOUT();

        if (!status) {
            return;
        }
        var response = JSON.parse(data);

        if (!data.status) {
            if (response.status === 'Failure') {
                setResponseMessage(response.Message);
                setSeverity('error');
                setIsError(true);
            }

            setStatus('PROCESS');
            setMessage(response.Message);
            setSeverity('success');
            setIsAlertErrorOpen(true);

            return;
        }
        setIsError(true);
        setSeverity('success');
        setResponseMessage(response.Message);

        resetForm(FormObj);

        setFormObj({
            ...FormObj,
            PANImage: {
                Name: '',
                Size: '',
                Type: '',
                Data: ''
            },

            AadharFrontImage: {
                Name: '',
                Size: '',
                Type: '',
                Data: ''
            },

            AadharBackImage: {
                Name: '',
                Size: '',
                Type: '',
                Data: ''
            }
        });
    };

    useEffect(() => {}, []);

    return (
        <CustomContainer
            isLoading={loadingOpen}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Grid container spacing={3}>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                    <h2 className={classes.PaperHead_h2}>
                        Merchant Activation
                    </h2>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                    <h4>
                        Each KYC file must be below 200 KB in size and in JPG
                        format.
                    </h4>
                </Grid>
            </Grid>

            <Formik
                enableReinitialize={true}
                initialValues={FormObj}
                validationSchema={FormValidationSchema}
                onSubmit={submithandle}
                resetForm={FormObj}
            >
                {({ setFieldValue }) => {
                    return (
                        <Form>
                            <Grid item xs={12}>
                                <Paper className={classes.PaperStyle}>
                                    <Grid container spacing={2}>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <label>Aadhar Image Front</label>
                                            <br />
                                            <TextField
                                                id="file1"
                                                name="DocumentFile"
                                                type="file"
                                                inputProps={{
                                                    accept: 'image/*'
                                                }}
                                                onChange={(event) => {
                                                    let {
                                                        files
                                                    } = event.target;
                                                    let file = files[0];

                                                    setAadharFrontImage(
                                                        URL.createObjectURL(
                                                            file
                                                        )
                                                    );

                                                    setFieldValue(
                                                        'AadharFrontImage.Name',
                                                        file.name
                                                    );
                                                    setFieldValue(
                                                        'AadharFrontImage.Size',
                                                        file.size
                                                    );
                                                    setFieldValue(
                                                        'AadharFrontImage.Type',
                                                        file.type
                                                    );

                                                    let reader = new FileReader();

                                                    reader.onload = ({
                                                        target: { result }
                                                    }) => {
                                                        setFieldValue(
                                                            'AadharFrontImage.Data',
                                                            result
                                                                .replace(
                                                                    'data:',
                                                                    ''
                                                                )
                                                                .replace(
                                                                    /^.+,/,
                                                                    ''
                                                                )
                                                        );
                                                    };
                                                    reader.readAsDataURL(file);
                                                }}
                                            />
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <img
                                                name="AadharFrontImage.Data"
                                                src={AadharImageFront}
                                                height={
                                                    AadharFrontImageDimension.height
                                                }
                                                width={
                                                    AadharFrontImageDimension.width
                                                }
                                                alt={AadharImageFront}
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <label>Aadhar Image Back</label>
                                            <br />
                                            <TextField
                                                id="file1"
                                                name="DocumentFile"
                                                type="file"
                                                inputProps={{
                                                    accept: 'image/*'
                                                }}
                                                onChange={(event) => {
                                                    let {
                                                        files
                                                    } = event.target;
                                                    let file = files[0];

                                                    setAadharBackImage(
                                                        URL.createObjectURL(
                                                            file
                                                        )
                                                    );

                                                    setFieldValue(
                                                        'AadharBackImage.Name',
                                                        file.name
                                                    );
                                                    setFieldValue(
                                                        'AadharBackImage.Size',
                                                        file.size
                                                    );
                                                    setFieldValue(
                                                        'AadharBackImage.Type',
                                                        file.type
                                                    );

                                                    let reader = new FileReader();

                                                    reader.onload = ({
                                                        target: { result }
                                                    }) => {
                                                        setFieldValue(
                                                            'AadharBackImage.Data',
                                                            result
                                                                .replace(
                                                                    'data:',
                                                                    ''
                                                                )
                                                                .replace(
                                                                    /^.+,/,
                                                                    ''
                                                                )
                                                        );
                                                    };
                                                    reader.readAsDataURL(file);
                                                }}
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <img
                                                name="AadharBackImage.Data"
                                                src={AadharImageBack}
                                                height={
                                                    AadharBackImageDimension.height
                                                }
                                                width={
                                                    AadharBackImageDimension.width
                                                }
                                                alt={AadharImageBack}
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <label>PAN Image</label>
                                            <br />
                                            <TextField
                                                id="file"
                                                name="DocumentFile"
                                                type="file"
                                                inputProps={{
                                                    accept: 'image/*'
                                                }}
                                                onChange={(event) => {
                                                    let {
                                                        files
                                                    } = event.target;
                                                    let file = files[0];

                                                    setPANImage(
                                                        URL.createObjectURL(
                                                            file
                                                        )
                                                    );

                                                    setFieldValue(
                                                        'PANImage.Name',
                                                        file.name
                                                    );
                                                    setFieldValue(
                                                        'PANImage.Size',
                                                        file.size
                                                    );
                                                    setFieldValue(
                                                        'PANImage.Type',
                                                        file.type
                                                    );

                                                    let reader = new FileReader();

                                                    reader.onload = ({
                                                        target: { result }
                                                    }) => {
                                                        setFieldValue(
                                                            'PANImage.Data',
                                                            result
                                                                .replace(
                                                                    'data:',
                                                                    ''
                                                                )
                                                                .replace(
                                                                    /^.+,/,
                                                                    ''
                                                                )
                                                        );
                                                    };
                                                    reader.readAsDataURL(file);
                                                }}
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <img
                                                name="PANImage.Data"
                                                src={ImagePAN}
                                                height={
                                                    PANImageDimension.height
                                                }
                                                width={PANImageDimension.width}
                                                alt={ImagePAN}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2}>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={9}
                                            lg={9}
                                        ></Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={2}
                                            lg={2}
                                        >
                                            <Box width="90%">
                                                <div
                                                    className={
                                                        classes.SubmitWrapper
                                                    }
                                                >
                                                    <PrimaryButton
                                                        type="submit"
                                                        title="Activate"
                                                        size="medium"
                                                        className={
                                                            classes.CustomPrimaryButtonStyle
                                                        }
                                                        fullWidth
                                                        disabled={loadingOpen}
                                                    >
                                                        Search
                                                    </PrimaryButton>

                                                    {loadingOpen && (
                                                        <CircularProgress
                                                            size={24}
                                                            className={
                                                                classes.buttonProgress
                                                            }
                                                        />
                                                    )}
                                                </div>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>
                        </Form>
                    );
                }}
            </Formik>
            {isAlertErrorOpen ? (
                <FailTransactionResponse
                    isOpen={isAlertErrorOpen}
                    title={status}
                    Message={Message}
                    OkButtonClick={(request) => {
                        setIsAlertErrorOpen(false);
                    }}
                />
            ) : null}
        </CustomContainer>
    );
};
